module.exports = __webpack_public_path__ + "hamburger-b17485fac8effb5049a59d398f9b51c0.svg";